import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getBibPreciosFiltered,
  deleteBibPrecios,
  insertBibPrecios,
  updateBibPrecios,
  getBibPreciosById,
  getBibPreciosExcelUrl,
  getProductosFiltered,
  updateProductosBibliotecaPrecios,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_BIBPRECIOS_FILTERED(action) {
  try {
    const bibPreciosData = yield call(getBibPreciosFiltered, action.payload)
    if (bibPreciosData.ok) {
      yield put({
        type: actions.BIBPRECIOS_FILTERED_LOAD_SUCCEEDED,
        payload: bibPreciosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar la Biblioteca de precios')
      put({
        type: actions.BIBPRECIOS_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBPRECIOS_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBPRECIOS_FILTERED(action) {
  try {
    const bibPreciosData = yield call(deleteBibPrecios, action.id)
    if (bibPreciosData.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de precios eliminada correctamente')
      yield put({
        type: actions.BIBPRECIOS_DELETED_SUCCEEDED,
        id: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al borrar la Biblioteca de precios')
      put({
        type: actions.BIBPRECIOS_DELETED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al borrar la Biblioteca de precios')
    yield all([
      put({
        type: actions.BIBPRECIOS_DELETED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBPRECIOS(action) {
  try {
    const bibPreciosData = yield call(insertBibPrecios, action.payload)
    if (bibPreciosData.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Precios creada correctamente')
      yield put({
        type: actions.BIBPRECIOS_INSERTED_SUCCEEDED,
        payload: bibPreciosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Precios')
      yield put({
        type: actions.BIBPRECIOS_INSERTED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Precios')
    yield all([
      put({
        type: actions.BIBPRECIOS_INSERTED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBPRECIOS(action) {
  try {
    const bibPreciosData = yield call(updateBibPrecios, action.payload)
    if (bibPreciosData.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Precios modificada correctamente')
      yield put({
        type: actions.BIBPRECIOS_UPDATED_SUCCEEDED,
        payload: bibPreciosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Precios')
      yield put({
        type: actions.BIBPRECIOS_UPDATED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Precios')
    yield all([
      put({
        type: actions.BIBPRECIOS_UPDATED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPRECIOS_BY_ID(action) {
  try {
    const bibPreciosData = yield call(getBibPreciosById, action.payload)
    if (bibPreciosData.ok) {
      yield put({
        type: actions.BIBPRECIOS_FILTERED_BY_ID_SUCCEEDED,
        payload: bibPreciosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Precios')
      put({
        type: actions.BIBPRECIOS_FILTERED_BY_ID_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Precios')
    yield all([
      put({
        type: actions.BIBPRECIOS_FILTERED_BY_ID_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPRECIOS_EXCEL_URL(action) {
  try {
    const bibPreciosData = yield call(getBibPreciosExcelUrl, action)
    if (bibPreciosData.ok) {
      yield put({
        type: actions.BIBPRECIOS_GET_URL_EXCEL_FILE_SUCCEEDED,
        payload: bibPreciosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al buscar el fichero excel de la Biblioteca de Precios')
      put({
        type: actions.BIBPRECIOS_GET_URL_EXCEL_FILE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al buscar el fichero excel de la Biblioteca de Precios')
    yield all([
      put({
        type: actions.BIBPRECIOS_GET_URL_EXCEL_FILE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPRECIOS_PRODUCTOS_FILTERED(action) {
  try {
    const productosData = yield call(getProductosFiltered, action.payload)
    if (productosData.ok) {
      yield put({
        type: actions.BIBPRECIOS_PRODUCTOS_FILTERED_SUCCEEDED,
        payload: productosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos')
      put({
        type: actions.BIBPRECIOS_PRODUCTOS_FILTERED_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBPRECIOS_PRODUCTOS_FILTERED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBPRECIOS_PRODUCTOS(action) {
  try {
    const productoBibPreciosData = yield call(updateProductosBibliotecaPrecios, action.payload)
    if (productoBibPreciosData.ok) {
      putMessage(
        messageType.SUCCESS,
        'Productos asociados a biblioteca de precios eliminado correctamente',
      )
      yield put({
        type: actions.BIBPRECIOS_PRODUCTOS_DELETED_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar la biblioteca de precios de los productos')
      yield put({
        type: actions.BIBPRECIOS_PRODUCTOS_DELETED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar la biblioteca de precios de los productos')
    yield all([
      put({
        type: actions.BIBPRECIOS_PRODUCTOS_DELETED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBPRECIOS_PRODUCTOS(action) {
  try {
    const productoBibPreciosData = yield call(updateProductosBibliotecaPrecios, action.payload)
    if (productoBibPreciosData.ok) {
      putMessage(
        messageType.SUCCESS,
        'Productos asociados a biblioteca de precios modificado correctamente',
      )
      yield put({
        type: actions.BIBPRECIOS_PRODUCTOS_UPDATED_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar la biblioteca de precios de los productos')
      yield put({
        type: actions.BIBPRECIOS_PRODUCTOS_UPDATED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar la biblioteca de precios de los productos')
    yield all([
      put({
        type: actions.BIBPRECIOS_PRODUCTOS_UPDATED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBPRECIOS_FILTERED_LOAD_REQUESTED, GET_BIBPRECIOS_FILTERED),
    takeEvery(actions.BIBPRECIOS_DELETED_REQUESTED, DELETE_BIBPRECIOS_FILTERED),
    takeEvery(actions.BIBPRECIOS_FILTERED_BY_ID_REQUESTED, GET_BIBPRECIOS_BY_ID),
    takeEvery(actions.BIBPRECIOS_INSERTED_REQUESTED, INSERT_BIBPRECIOS),
    takeEvery(actions.BIBPRECIOS_UPDATED_REQUESTED, UPDATE_BIBPRECIOS),
    takeEvery(actions.BIBPRECIOS_GET_URL_EXCEL_FILE_REQUESTED, GET_BIBPRECIOS_EXCEL_URL),
    takeEvery(actions.BIBPRECIOS_PRODUCTOS_FILTERED_REQUESTED, GET_BIBPRECIOS_PRODUCTOS_FILTERED),
    takeEvery(actions.BIBPRECIOS_PRODUCTOS_DELETED_REQUESTED, DELETE_BIBPRECIOS_PRODUCTOS),
    takeEvery(actions.BIBPRECIOS_PRODUCTOS_UPDATED_REQUESTED, UPDATE_BIBPRECIOS_PRODUCTOS),
  ])
}
